// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  /* 
   * Common check for enabling animations - both features
   * only work when the animate-elements class exists
   */
  const animateElement = document.querySelector('.animate-elements');
  const animationsEnabled = animateElement !== null;
  
  // If animations are not enabled, exit early
  if (!animationsEnabled) {
    return;
  }

  /* === FADE-UP ANIMATION FUNCTIONALITY === */
  // Helper functions for visibility detection
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.9 &&
      rect.bottom >= 0
    );
  }

  // Special sections configuration
  const specialSections = {
      'wp-block-block-builder-federalgroup-four-tile-row': 'four-tile-row__wrapper',
      'wp-block-block-builder-federalgroup-special-offers' : 'special-offer__wrapper',
      'wp-block-block-builder-federalgroup-activity-tiles': 'activity-tile__wrapper',
      'wp-block-block-builder-federalgroup-two-cols-media-text' : 'flex-column-wrapper',
      'wp-block-block-builder-federalgroup-things-to-do' :'things-card-row__glide',
      'wp-block-block-builder-federalgroup-two-cols-club-overlay' : 'two-cols-club-overlay__content-container',
      'wp-block-block-builder-federalgroup-icon-card-row' : 'icon-card-row__wrapper',
      'wp-block-block-builder-federalgroup-home-page-banner' : 'home-page-banner__content-wrapper',
      'wp-block-block-builder-federalgroup-rooms-grid' : 'rooms-grid__container',
      'wp-block-block-builder-federalgroup-tile-row' : 'tile-row__wrapper',
      'wp-block-block-builder-federalgroup-two-cols-flag-overlay' :'two-cols-flag-overlay__flex-column',
  };
  
  // List of elements that could be sticky (if they're the first element)
  const potentialStickyClasses = [
      'wp-block-block-builder-federalgroup-home-page-banner',
      'wp-block-block-builder-federalgroup-hero-banner-with-cta',
  ];
  
  // List of elements that should NOT be animated
  const noAnimationClasses = [
      'wp-block-block-builder-federalgroup-full-width-image-banner',
      'wp-block-block-builder-federalgroup-on-page-menu',
      'wp-block-block-builder-federalgroup-full-width-image'
  ];
  
  // Find the entry content
  const entryContent = document.querySelector('.entry-content');
  let stickyBanner = null;
  let stickyBannerHeight = 0;
  let quarterHeight = 0;
  
  // Track which elements should not be animated (initially the sticky banner)
  const elementsToSkipAnimation = new Set();
  
  // Identify the element that could be sticky (first matching element)
  if (entryContent && entryContent.children.length > 0) {
      const firstChild = entryContent.children[0];
      
      // Check if the first child is one of our potential sticky elements
      for (const className of potentialStickyClasses) {
          if (firstChild.classList.contains(className)) {
              stickyBanner = firstChild;
              stickyBannerHeight = stickyBanner.offsetHeight;
              quarterHeight = Math.floor(stickyBannerHeight * 0.25); // Using 25% instead of 50%
              
              // Prepare the sticky banner with a custom property for the negative top value
              stickyBanner.style.setProperty('--quarter-height', `-${quarterHeight}px`);
              
              elementsToSkipAnimation.add(firstChild); // Skip animation for the sticky banner
              break;
          }
      }
  }
  
  // Function to check if an element should be excluded from animation
  function shouldSkipAnimation(element) {
      // Skip if this element is the sticky banner
      if (elementsToSkipAnimation.has(element)) {
          return true;
      }
      
      // Skip if this element is in the no-animation list
      for (const className of noAnimationClasses) {
          if (element.classList.contains(className)) {
              return true;
          }
      }
      return false;
  }
  
  // Select all Federal Group elements
  const federalBlocks = document.querySelectorAll('[class*="wp-block-block-builder-federalgroup"]');
  const animatedElements = [];
  
  // First, collect any elements that already have the fade-up class
  const preExistingFadeElements = document.querySelectorAll('.fade-up');
  preExistingFadeElements.forEach(element => {
    if (!animatedElements.includes(element)) {
      animatedElements.push(element);
    }
  });

  // Process federal blocks for animations
  federalBlocks.forEach(block => {
    // Skip if this element should not be animated
    if (shouldSkipAnimation(block)) {
      return;
    }
    
    // Skip if this block already has a fade-up class somewhere
    if (block.querySelector('.fade-up')) {
      const blockFadeElements = block.querySelectorAll('.fade-up');
      blockFadeElements.forEach(element => {
        if (!animatedElements.includes(element)) {
          animatedElements.push(element);
        }
      });
      return;
    }
    
    // Check if this is a special section
    let isSpecialSection = false;
    let targetElement = null;
    
    for (const className in specialSections) {
      if (block.classList.contains(className)) {
        isSpecialSection = true;
        targetElement = block.querySelector('.' + specialSections[className]);
        break;
      }
    }
    
    if (isSpecialSection && targetElement) {
      if (!targetElement.classList.contains('fade-up')) {
        targetElement.classList.add('fade-up');
      }
      
      if (!animatedElements.includes(targetElement)) {
        animatedElements.push(targetElement);
      }
    } else {
      // Standard case: animate the first div
      const firstDiv = block.querySelector('div');
      
      if (firstDiv) {
        if (!firstDiv.classList.contains('fade-up')) {
          firstDiv.classList.add('fade-up');
        }
        
        if (firstDiv.classList.contains('activity-tile__card') || 
            firstDiv.classList.contains('accordion__item') || 
            firstDiv.classList.contains('activity-row__card')) {
          firstDiv.classList.add('fade-up-stagger');
        }
        
        if (!animatedElements.includes(firstDiv)) {
          animatedElements.push(firstDiv);
        }
      }
    }
  });

  // Track last scroll position to determine scroll direction
  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
  // Track elements that are currently in the viewport
  const inViewportElements = new Set();
  
  // Function to handle scroll events for fade animations
  function handleScroll() {
    // Get current scroll position
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Determine if scrolling down
    const isScrollingDown = currentScrollTop > lastScrollTop;
    
    // Update last scroll position for next check
    lastScrollTop = currentScrollTop;
    
    animatedElements.forEach(element => {
      const inView = isInViewport(element);
      
      // Check if element is visible in viewport
      if (inView) {
        // Element is in viewport
        inViewportElements.add(element);
        
        // Only add animations when scrolling down
        if (isScrollingDown && !element.classList.contains('visible')) {
          element.classList.add('visible');
        }
      } else {
        // Element is out of viewport
        
        // If we were scrolling up AND the element was previously in viewport,
        // now is the time to reset it since it's now out of viewport
        if (!isScrollingDown && inViewportElements.has(element)) {
          element.classList.remove('visible');
        }
        
        // Mark that this element is no longer in viewport
        inViewportElements.delete(element);
      }
    });
    
    // Handle sticky banner toggling at quarter point (25%)
    if (stickyBanner) {
      if (window.scrollY > quarterHeight) {
        if (!stickyBanner.classList.contains('sticky-banner')) {
          stickyBanner.classList.add('sticky-banner');
          stickyBanner.classList.add('with-overlay');
        }
      } else {
        if (stickyBanner.classList.contains('sticky-banner')) {
          stickyBanner.classList.remove('sticky-banner');
          stickyBanner.classList.remove('with-overlay');
        }
      }
    }
  }

  // Initial animation for elements visible on page load
  animatedElements.forEach(element => {
    if (isInViewport(element)) {
      // Element is visible on initial load, animate it in
      element.classList.add('visible');
      // Mark as in viewport
      inViewportElements.add(element);
    }
  });
  
  // Add scroll event listener with throttling for performance
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    if (scrollTimeout) {
      window.cancelAnimationFrame(scrollTimeout);
    }
    
    scrollTimeout = window.requestAnimationFrame(handleScroll);
  });
});